import { useState } from "react";
import { Collapse } from "../../../../../components/motion";
import { cn } from "../../../../../utils/classnames";
import { ExpandToggleSign } from "./ExpandToggleSign";

const NOTE_GOLD = "#9A7B3F";

/**
 * Collapsed-by-default callout for details only some guests need, such as when
 * a meet service is required. The gold title on a warm panel marks it as
 * supporting info rather than part of the main story.
 *
 * The body slides open instead of appearing at once, so the guest can see
 * where the new text came from.
 */
export const ExpandableNote = ({ title, body, className }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div
      className={cn(
        "tw:bg-[#F6F4F0] tw:rounded-[8px] tw:px-5 tw:lg:px-7 tw:py-5 tw:lg:py-6",
        className
      )}
    >
      <button
        type="button"
        onClick={() => setIsOpen((wasOpen) => !wasOpen)}
        aria-expanded={isOpen}
        className="tw:w-full tw:bg-transparent tw:border-0 tw:p-0 tw:flex tw:items-center tw:justify-between tw:gap-x-4 tw:text-left tw:cursor-pointer"
      >
        <span className="tw:font-hanken-grotesk tw:text-[15px] tw:leading-[22px] tw:text-[#9A7B3F]">
          {title}
        </span>
        <ExpandToggleSign isOpen={isOpen} color={NOTE_GOLD} size={11} />
      </button>

      <Collapse isOpen={isOpen}>
        <div className="tw:h-px tw:bg-[#E7E2D8] tw:mt-[17px] tw:mb-[18px] tw:lg:mr-[55px]" />
        <div className="tw:lg:mr-[55px] tw:font-hanken-grotesk tw:text-[#4E4E4E] tw:text-[13px] tw:leading-[19px]">
          {body}
        </div>
      </Collapse>
    </div>
  );
};
